import { render } from "./DesignRowAndColGesture.vue?vue&type=template&id=438a3341&scoped=true"
import script from "./DesignRowAndColGesture.vue?vue&type=script&lang=js"
export * from "./DesignRowAndColGesture.vue?vue&type=script&lang=js"

import "./DesignRowAndColGesture.vue?vue&type=style&index=0&id=438a3341&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438a3341"]])

export default __exports__